import "./SubjectConfirmation.css";
import { Grid2 } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import {
  formatDateWithoutTime,
  formatDynamicObject,
  safelyParse,
  validDateValueRegex,
} from "../../../utilities/helper";
import { findNode, findTitleByReceivedId, stripHtml } from "./helper";

const SubjectConfirmation = ({
  data,
  pageName,
  setShowConfirm,
  languageData,
  showLinks = true,
}) => {
  const navigate = useNavigate();
  const json = JSON.parse(data?.questions[0]?.json);


  // function getLastJson(questions) {
  //   for (let i = questions?.length - 1; i >= 0; i--) {
  //     if (
  //       questions[i]?.id !== "00000000-0000-0000-0000-000000000000" &&
  //       questions[i]?.questionnaireId !== "00000000-0000-0000-0000-000000000000"
  //     ) {
  //       return questions[i]?.json;
  //     }
  //   }
  // }


  const getQuestionLabel = (element) => {
    const item = element?.answers[0];
    const idRequired = item?.questionId;
    const key =
      idRequired === "00000000-0000-0000-0000-000000000000"
        ? item?.value
        : findNode(json, idRequired);
    if (
      element?.choices &&
      Array.isArray(element?.choices) &&
      element?.choices.length > 0
    ) {
      const matchedChoice = element?.choices?.find(
        (ele) => ele?.id == item?.value,
      );
      const foundOptionLabel = matchedChoice?.choiceDisplayText
        ? stripHtml(matchedChoice.choiceDisplayText)
        : null;

      return foundOptionLabel
        ? foundOptionLabel
        : formatDynamicObject(safelyParse(item?.value));
    } else if (
      key?.choices &&
      Array.isArray(key?.choices) &&
      key?.choices?.length > 0
    ) {
      const foundOptionLabel = key?.choices?.find(
        (ele) => ele?.value == item?.value,
      )?.text;
      return foundOptionLabel
        ? foundOptionLabel
        : formatDynamicObject(safelyParse(item?.value));
    }
    return formatDynamicObject(safelyParse(item?.value));
  };

  return (
    <div className="content-body">
      {showLinks && (
        <p
          className="bread-crumbs-link-container"
          style={{ fontWeight: "600" }}
        >
          <Link className="bread-crumbs-link" to="/">
            Home
          </Link>{" "}
          |{" "}
          <Link
            className="bread-crumbs-link"
            to="/subject"
            onClick={() => setShowConfirm(false)}
          >
            Subject Management
          </Link>
          | <Link className="bread-crumbs-link">Subject Confirmation</Link>-{" "}
          <b style={{ color: "gray" }}>{localStorage?.getItem("studyName")}</b>
        </p>
      )}

      <div
        className="subject-container"
        style={{
          marginTop: showLinks ? "0px" : "-40px",
        }}
      >
        <div className="subject-confirmation-container">
          <span className="subject-heading">{pageName}</span>
          <span
            className="subject-heading"
            style={{
              fontSize: "14px",
            }}
          >
            {data?.patientDto?.patientNumber}
          </span>
          <span className="confirmation-heading">
            Confirmation of {pageName}
          </span>
        </div>
        <div className="subject-details-container">
          {languageData?.id !== "00000000-0000-0000-0000-000000000000" &&
          languageData !== undefined ? (
            <div className="subject-details">
              <span className="subject-detail-name">Language</span>
              <span className="subject-detail-value">{languageData?.name}</span>
            </div>
          ) : null}
          {data?.questions
            ?.filter((item) => {
              const value = item?.answers?.[0]?.value;
              return value !== null && value !== undefined && value !== "";
            })
            ?.map((item, index) => {
              // const key = item?.questionDisplayText;
              const idRequired = item?.id;
              const rawValue = item?.answers?.[0]?.value;
              const key =
                idRequired === "00000000-0000-0000-0000-000000000000"
                  ? item?.questionDisplayText
                  : findTitleByReceivedId(json, idRequired);

              const skipKey = key === "Visit Name: " || key === "Visit Date: ";

              let displayValue = rawValue;

              // Try parsing if value is a stringified object
              try {
                const parsed =
                  typeof rawValue === "string"
                    ? JSON.parse(rawValue)
                    : rawValue;

                if (parsed && parsed.start && parsed.end) {
                  displayValue = `${formatDateWithoutTime(
                    parsed.start,
                  )} - ${formatDateWithoutTime(parsed.end)}`;
                }
              } catch (e) {
                // leave displayValue as-is if parsing fails
              }

              return (
                <div key={index} className="subject-details">
                  {!skipKey && key && (
                    <span className="subject-detail-name">{key}</span>
                  )}

                  {typeof rawValue === "string" &&
                  rawValue?.startsWith("data:image/") &&
                  rawValue?.includes("base64") ? (
                    <img
                      style={{
                        width: "200px",
                        maxHeight: 600,
                        objectFit: "contain",
                      }}
                      src={rawValue}
                      alt="base64"
                    />
                  ) : (
                    !skipKey && (
                      <span className="subject-detail-value">
                        {validDateValueRegex.test(displayValue)
                          ? formatDateWithoutTime(displayValue)
                          : getQuestionLabel(item)}
                      </span>
                    )
                  )}
                </div>
              );
            })}
        </div>
      </div>

      <div className="main-subject-details-container">
        <div className="main-details-container">
          {languageData?.id !== "00000000-0000-0000-0000-000000000000" &&
          languageData !== undefined ? (
            <div className="main-subject-details">
              <span className="main-subject-key">Language</span>:
              <span className="main-subject-value">{languageData?.name}</span>
            </div>
          ) : null}
          {data?.questions
            ?.filter((item) => {
              const value = item?.answers?.[0]?.value;
              return value !== null && value !== undefined && value !== "";
            })
            ?.map((item, index) => {
              // const key = item?.questionDisplayText;
              const idRequired = item?.id;

              const key =
                idRequired === "00000000-0000-0000-0000-000000000000"
                  ? item?.questionDisplayText
                  : findTitleByReceivedId(json, idRequired);
              const rawValue = item?.answers?.[0]?.value;

              if (!key || key.trim() === "") return null;

              let displayValue = rawValue;
              try {
                const parsed =
                  typeof rawValue === "string"
                    ? JSON.parse(rawValue)
                    : rawValue;

                if (parsed && parsed.start && parsed.end) {
                  displayValue = `${formatDateWithoutTime(
                    parsed.start,
                  )} - ${formatDateWithoutTime(parsed.end)}`;
                }
              } catch (e) {
                // Parsing failed — use rawValue as-is
              }

              return (
                <div key={index} className="main-subject-details">
                  {typeof rawValue === "string" &&
                  rawValue?.startsWith("data:image/") &&
                  rawValue?.includes("base64") ? (
                    <>
                      <span className="main-subject-key">{key}</span>:
                      <img
                        style={{
                          width: "200px",
                          maxHeight: 600,
                          objectFit: "contain",
                          marginLeft: "10px",
                        }}
                        src={rawValue}
                        alt="base64"
                      />
                    </>
                  ) : (
                    <>
                      <span className="main-subject-key">
                        {key?.includes(":") ? key.split(":")[0] : key}
                      </span>
                      :
                      <span className="main-subject-value">
                        {" "}
                        {validDateValueRegex.test(displayValue)
                          ? formatDateWithoutTime(displayValue)
                          : getQuestionLabel(item)}
                      </span>
                    </>
                  )}
                </div>
              );
            })}
          {/* 
          <div className="main-subject-details">
            <span className="main-subject-key">Subject Status</span>:
            <span className="main-subject-value">
              {data?.patientDto?.patientStatus}
            </span>
          </div> */}
        </div>
      </div>

      <Grid2
        alignItems={"center"}
        justifyContent="center"
        container
        gap={3}
        sx={{ marginTop: "2%" }}
      >
        <Grid2 item md={6}>
          <button
            className="create-btn"
            onClick={() => {
              navigate("/subject");
            }}
          >
            View Subject
          </button>
        </Grid2>
      </Grid2>
    </div>
  );
};

export default SubjectConfirmation;
